/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["miezul nopții","la amiază","dimineața","după-amiaza","seara","noaptea"],["miezul nopții","amiază","dimineața","după-amiaza","seara","noaptea"],["la miezul nopții","la amiază","dimineața","după-amiaza","seara","noaptea"]],[["miezul nopții","amiază","dimineața","după-amiaza","seara","noaptea"],u,["la miezul nopții","la amiază","dimineața","după-amiaza","seara","noaptea"]],["00:00","12:00",["05:00","12:00"],["12:00","18:00"],["18:00","22:00"],["22:00","05:00"]]];
